import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  clearClient,
  setClient,
  setClientID,
  setProjectID,
} from "../../../../../Redux/Actions/actions";
import useAdminClients from "../../../Admin/AdminQueries/useAdminClients";
import { DashboardContext } from "../../../DashboardContext/DashboardContextProvider";
import "../styles/form-container.css";
import "./styles/intro-slide.css";

// Slide 0: Introduction
const IntoSlide = () => {
  const dispatch = useDispatch();
  const [selectedClient, setSelectedClient] = useState("");

  const { queryClient, isAdmin } = useContext(DashboardContext);

  // + GET ALL CLIENTS FOR SELECT
  const { data: clientsData, isFetched: clientsFetched } =
    useAdminClients(isAdmin);

  useEffect(() => {
    console.log("clientsData", clientsData);
  }, [clientsData]);

  return (
    <>
      {isAdmin && clientsFetched ? (
        <FormControl
          id={"clientSelectForm"}
          classes={{ root: "clientSelectFormRoot" }}
        >
          <InputLabel
            id={`${"clientSelectLabel"}`}
            classes={{ shrink: "labelShrink" }}
            htmlFor={`${"clientSelect"}`}
          >
            Select a Client
          </InputLabel>
          <Select
            id="select-field"
            labelId="select-field-label"
            className={`company-select-input`}
            label={`Select a client`}
            value={selectedClient}
            onChange={(e) => {
              console.log("Selected Client ID:", e.target.value);
              if (e.target.value === "") {
                dispatch(setClientID(null));
                dispatch(setProjectID(null));
                dispatch(clearClient());
                setSelectedClient(null);
                queryClient.invalidateQueries({
                  queryKey: "adminClients",
                });
              } else {
                dispatch(setClientID(e.target.value));
                dispatch(
                  setClient(
                    clientsData.filter((c) => c.id === e.target.value)[0],
                  ),
                );
                setSelectedClient(e.target.value);
                queryClient.invalidateQueries({
                  queryKey: ["adminClients", isAdmin, e.target.value],
                });
              }
            }}
            MenuProps={{
              id: "select-field-menu",
              className: "select-field-menu",
              classes: { paper: "select-field-paper" },
            }}
            inputProps={{
              id: "select-input",
              name: "select-input",
            }}
            autoComplete="off"
            autoCapitalize="words"
            classes={{
              root: "select-field-root",
              input: "select-field-input",
            }}
          >
            <MenuItem
              value={""}
              id="select-field-placeholder"
              className="select-placeholder"
            >
              Clear Field
            </MenuItem>
            {clientsData.map((client) => (
              <MenuItem
                key={client.id}
                value={client.id}
                className="select-menu-item"
              >
                {client.shortName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : isAdmin && !clientsData ? (
        <p className={"loadingP"}>Loading...</p>
      ) : null}
    </>
  );
};

export default IntoSlide;
